import { FOCUS_STYLES } from '../../../../../designSystem/reloaded/commons/foundations/focusStyles';
import { FONT_STYLE, FONT_WEIGHT } from '../../../../../designSystem/reloaded/commons/foundations/typography';
import { RESET_STYLES } from '../../reset';
export const RELOADED_NOVA_GLOBAL_STYLES = (FOUNDATIONS, elementContainer) => `
  ${elementContainer ? elementContainer : ''} {
    ${RESET_STYLES}
    html,
  body,
  * {
      font-family: 'Outfit Font', sans-serif;
    }
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
    :focus-visible {
      ${FOCUS_STYLES(FOUNDATIONS)}
    }
    strong,
    b {
      font-weight: ${FONT_WEIGHT.font_bold};
    }

    i,
    em {
      font-style: ${FONT_STYLE.font_italic};
    }
  }
`;
//# sourceMappingURL=globalStyles.js.map